"use client";
import { RouteError } from "@/components/RouteError";

export default function StudioError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <RouteError
      error={error}
      reset={reset}
      label="STUDIO ERROR"
      backHref="/dashboard"
      backLabel="Back to Dashboard"
    />
  );
}
